module.exports = "/_next/static/images/f84a97ed776366f5f2a9031c8e543e96-improving.svg";